module.exports = __webpack_public_path__ + "img/icon-note-light-blue.34c83847.svg";